import { makeAutoObservable } from 'mobx';
import type { CollectionGame } from '../services/collectionStorage';

class CollectionNavStore {
  games: CollectionGame[] = [];
  currentIndex = -1;

  constructor() {
    makeAutoObservable(this);
  }

  get isActive() { return this.currentIndex >= 0 && this.games.length > 0; }
  get hasPrev()  { return this.currentIndex > 0; }
  get hasNext()  { return this.currentIndex < this.games.length - 1; }
  get currentGame(): CollectionGame | null {
    return this.isActive ? this.games[this.currentIndex] : null;
  }

  setContext(games: CollectionGame[], index: number) {
    this.games = games;
    this.currentIndex = index;
  }

  clear() {
    this.games = [];
    this.currentIndex = -1;
  }

  prev() { if (this.hasPrev) this.currentIndex--; }
  next() { if (this.hasNext) this.currentIndex++; }
}

export const collectionNavStore = new CollectionNavStore();
